import { render, staticRenderFns } from "./Editorjsrender.vue?vue&type=template&id=ec56e002&"
import script from "./Editorjsrender.vue?vue&type=script&lang=js&"
export * from "./Editorjsrender.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports